import "./swiperAPI";
import "./localizedData";
import "./cardTemplate";

document.addEventListener("DOMContentLoaded", () => {
  const { initAll } = window?.CarouselAPI?.SwiperAPI || {};
  initAll();
});
